export default function BooksSection() {
  return (
    <section id="books" className="w-full bg-background-300 relative overflow-hidden scroll-mt-20">
      {/* Nature & adventure decorations */}
      <div className="absolute inset-0 pointer-events-none select-none z-0" aria-hidden="true">
        <div className="w-12 h-12 flex items-center justify-center absolute top-[12%] left-[6%] opacity-[0.06] rotate-[-20deg] animate-float" style={{ animationDelay: '0s' }}>
          <i className="fa-solid fa-feather-pointed text-4xl text-foreground-950"></i>
        </div>
        <div className="w-10 h-10 flex items-center justify-center absolute top-[18%] right-[8%] opacity-[0.05] rotate-[30deg] animate-drift" style={{ animationDelay: '1.1s' }}>
          <i className="fa-solid fa-leaf text-3xl text-foreground-950"></i>
        </div>
        <div className="w-14 h-14 flex items-center justify-center absolute top-[45%] left-[3%] opacity-[0.04] rotate-[15deg] animate-drift" style={{ animationDelay: '2.2s' }}>
          <i className="fa-solid fa-feather-pointed text-5xl text-foreground-950"></i>
        </div>
        <div className="w-10 h-10 flex items-center justify-center absolute top-[50%] right-[5%] opacity-[0.06] rotate-[-35deg] animate-float" style={{ animationDelay: '3.3s' }}>
          <i className="fa-solid fa-leaf text-3xl text-foreground-950"></i>
        </div>
        <div className="w-12 h-12 flex items-center justify-center absolute top-[72%] left-[10%] opacity-[0.05] rotate-[25deg] animate-float" style={{ animationDelay: '4.4s' }}>
          <i className="fa-solid fa-feather-pointed text-4xl text-foreground-950"></i>
        </div>
        <div className="w-10 h-10 flex items-center justify-center absolute top-[78%] right-[10%] opacity-[0.05] rotate-[-15deg] animate-drift" style={{ animationDelay: '5.5s' }}>
          <i className="fa-solid fa-leaf text-3xl text-foreground-950"></i>
        </div>
        <div className="w-14 h-14 flex items-center justify-center absolute top-[30%] left-[40%] opacity-[0.03] rotate-[45deg] animate-drift" style={{ animationDelay: '1.8s' }}>
          <i className="fa-solid fa-feather-pointed text-5xl text-foreground-950"></i>
        </div>
        <div className="w-10 h-10 flex items-center justify-center absolute top-[88%] right-[25%] opacity-[0.06] rotate-[-50deg] animate-float" style={{ animationDelay: '2.7s' }}>
          <i className="fa-solid fa-leaf text-3xl text-foreground-950"></i>
        </div>
      </div>

      <div className="w-full h-48 md:h-80 overflow-hidden relative z-10">
        <video
          src="https://cdn.gamma.app/z4s3rpnzx64fspv/edited-images/Bd9v3v-bRXJf7sCN4alkv.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-16 relative z-10">
        <p className="text-center text-secondary-500 text-sm font-semibold mb-3 italic">Pssst… discover our Magical Book Collection</p>

        <h2 className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3">Discover Our Magical Book Collection</h2>

        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-12 max-w-2xl mx-auto">
          Join Gracie and Lily on 13 enchanting adventures filled with friendship, kindness, bravery, and magic!
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-10">
          <div className="bg-white/60 rounded-2xl p-5 md:p-6 flex flex-col gap-4">
            <div className="w-full h-44 rounded-xl relative overflow-hidden ring-4 ring-white drop-shadow-[0_8px_20px_rgba(0,0,0,0.15)] cursor-pointer hover:scale-105 transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-500/25 via-primary-400/15 to-accent-400/20"></div>
              <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-primary-500/30 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className="fa-solid fa-book text-5xl text-primary-500"></i>
                </div>
              </div>
            </div>
            <h3 className="text-lg font-extrabold text-primary-500">Print Books</h3>
            <p className="text-foreground-700 text-sm leading-relaxed flex-1">
              Beautiful hardcover editions with stunning illustrations, perfect for your child's library.
            </p>
            <a
              href="https://gracie-and-lilys-adventures.myshopify.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary-500 text-white px-4 py-2.5 rounded-lg font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors text-center"
            >
              Shop Books
            </a>
          </div>

          <div className="bg-white/60 rounded-2xl p-5 md:p-6 flex flex-col gap-4">
            <div className="w-full h-44 rounded-xl relative overflow-hidden ring-4 ring-white drop-shadow-[0_8px_20px_rgba(0,0,0,0.15)] cursor-pointer hover:scale-105 transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-500/25 via-accent-400/15 to-secondary-400/20"></div>
              <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-accent-500/30 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className="fa-solid fa-tablet-screen-button text-5xl text-accent-500"></i>
                </div>
              </div>
            </div>
            <h3 className="text-lg font-extrabold text-primary-500">Digital Flipbooks</h3>
            <p className="text-foreground-700 text-sm leading-relaxed flex-1">
              Instant access to interactive flipbooks your kids can read anytime, anywhere!
            </p>
            <a
              href="https://gladventures.gumroad.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary-500 text-white px-4 py-2.5 rounded-lg font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors text-center"
            >
              View Flipbooks
            </a>
          </div>

          <div className="bg-white/60 rounded-2xl p-5 md:p-6 flex flex-col gap-4">
            <div className="w-full h-44 rounded-xl relative overflow-hidden ring-4 ring-white drop-shadow-[0_8px_20px_rgba(0,0,0,0.15)] cursor-pointer hover:scale-105 transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary-500/25 via-secondary-400/15 to-primary-400/20"></div>
              <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-secondary-500/30 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className="fa-solid fa-layer-group text-5xl text-secondary-500"></i>
                </div>
              </div>
            </div>
            <h3 className="text-lg font-extrabold text-primary-500">Bundle Deals</h3>
            <p className="text-foreground-700 text-sm leading-relaxed flex-1">
              Save big with our curated adventure bundles — the perfect gift for young readers!
            </p>
            <a
              href="https://gladventures.gumroad.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary-500 text-white px-4 py-2.5 rounded-lg font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors text-center"
            >
              View Bundle Deals
            </a>
          </div>

          <div className="bg-white/60 rounded-2xl p-5 md:p-6 flex flex-col gap-4">
            <div className="w-full h-44 rounded-xl relative overflow-hidden ring-4 ring-white drop-shadow-[0_8px_20px_rgba(0,0,0,0.15)] cursor-pointer hover:scale-105 transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-br from-foreground-400/20 via-foreground-300/12 to-accent-400/20"></div>
              <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-foreground-300/25 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className="fa-solid fa-shirt text-5xl text-foreground-600"></i>
                </div>
              </div>
            </div>
            <h3 className="text-lg font-extrabold text-primary-500">Shop Merchandise</h3>
            <p className="text-foreground-700 text-sm leading-relaxed flex-1">
              T-shirts, stickers, posters, and more featuring your favourite Bichon sisters — Gracie & Lily!
            </p>
            <a
              href="https://gracie-and-lilys-adventures.myshopify.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary-500 text-white px-4 py-2.5 rounded-lg font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors text-center"
            >
              Shop Merchandise
            </a>
          </div>
        </div>

        <div className="bg-primary-300 border-l-4 border-primary-600 rounded-2xl p-5 md:p-7">
          <p className="text-primary-700 font-bold text-sm mb-2">🎉 BEST VALUE</p>
          <h3 className="text-xl md:text-2xl font-black text-primary-500 mb-2">Complete 13-Book Adventure Collection</h3>
          <p className="text-foreground-700 text-sm mb-4">
            Save big when you get all 13 magical adventures together! The perfect gift for young readers.
          </p>
          <a
            href="https://gladventures.gumroad.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-primary-500 text-white px-6 py-2.5 rounded-lg font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors"
          >
            View Bundle Deals
          </a>
        </div>
      </div>
    </section>
  );
}